import React from "react"

export const FirstRespondersQuestionsAndContactComponent = () => {
  return (
    <>
    <p>Questions before you continue? Find answers <a href="https://www.t-mobile.com/cell-phone-plans/first-responder-discounts">here</a>.</p>
    </>
  )
}

